import { Select, SelectProps } from '@chakra-ui/react';
import { useMemo } from 'react';
import { FieldPath, UseFormReturn } from 'react-hook-form';

type Props<TFieldValues> = SelectProps & {
  name: FieldPath<TFieldValues>;
  register: UseFormReturn<TFieldValues>['register'];
  children?: React.ReactNode;
  isCheckUnnecessaryApiKey?: boolean;
};

export const ApiKeyTemplateSelect = <TFieldValues,>({
  name,
  register,
  children,
  isCheckUnnecessaryApiKey,
  ...selectProps
}: Props<TFieldValues>) => {
  const requiredMessage = useMemo(
    () => (isCheckUnnecessaryApiKey ? false : '必須項目です'),
    [isCheckUnnecessaryApiKey],
  );

  return (
    <Select
      {...register(name, {
        required: requiredMessage,
      })}
      {...selectProps}
      isDisabled={!requiredMessage}
    >
      {children}
    </Select>
  );
};
